import { FC } from 'react';
import ToggleButtonFormField from '@acorn-portal/shared/src/components/inputs/toggle-button-form-field';
import { FormikProps } from 'formik';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { IOptions } from '@acorn-portal/shared/src/components/inputs/select';
import { BUSINESS_RADIUS, DANGEROUS_GOODS } from '@acorn-portal/shared/src/utils/modalText';
import RadioGroupButton from '@acorn-portal/shared/src/components/inputs/radio-button-group';
import { IChangeOfVehiclePart2 } from '@acorn-portal/shared/src/models/midTermAdjustment-model';

interface IProps {
	formik: FormikProps<IChangeOfVehiclePart2>;
}

const CvAdditionalQuestions: FC<IProps> = ({ formik }) => {
	const lists = useAppSelector((redux) => redux.referenceData);

	return (
		<>
			<ToggleButtonFormField
				label='What is your business radius?'
				name='businessRadius'
				id='businessRadius'
				value={formik.values.businessRadius}
				onChange={(value) => formik.setFieldValue('businessRadius', value)}
				options={lists.businessRadius as IOptions[]}
				modal={{
					title: BUSINESS_RADIUS.header,
					description: BUSINESS_RADIUS.text,
				}}
				error={formik.touched.businessRadius && Boolean(formik.errors.businessRadius)}
				helperText={formik.touched.businessRadius && formik.errors.businessRadius}
			/>
			<RadioGroupButton
				label='Does the vehicle have internal racking?'
				name='hasInternalRacking'
				id='hasInternalRacking'
				value={formik.values.hasInternalRacking}
				onChange={(value) => formik.setFieldValue('hasInternalRacking', value)}
				error={formik.touched.hasInternalRacking && Boolean(formik.errors.hasInternalRacking)}
				helperText={formik.touched.hasInternalRacking && formik.errors.hasInternalRacking}
			/>
			<RadioGroupButton
				label='Will the vehicle carry dangerous goods?'
				name='vehicleCarriesDangerousGoods'
				id='vehicleCarriesDangerousGoods'
				value={formik.values.vehicleCarriesDangerousGoods}
				onChange={(value) => formik.setFieldValue('vehicleCarriesDangerousGoods', value)}
				modal={{
					title: DANGEROUS_GOODS.header,
					description: DANGEROUS_GOODS.text,
				}}
				error={formik.touched.vehicleCarriesDangerousGoods && Boolean(formik.errors.vehicleCarriesDangerousGoods)}
				helperText={formik.touched.vehicleCarriesDangerousGoods && formik.errors.vehicleCarriesDangerousGoods}
			/>
			<RadioGroupButton
				label='Will the vehicle visit hazardous sites?'
				name='vehicleVisitsHazardousSites'
				id='vehicleVisitsHazardousSites'
				value={formik.values.vehicleVisitsHazardousSites}
				onChange={(value) => formik.setFieldValue('vehicleVisitsHazardousSites', value)}
				error={formik.touched.vehicleVisitsHazardousSites && Boolean(formik.errors.vehicleVisitsHazardousSites)}
				helperText={formik.touched.vehicleVisitsHazardousSites && formik.errors.vehicleVisitsHazardousSites}
			/>
		</>
	);
};

export default CvAdditionalQuestions;
